import { createAction } from 'redux-actions';
import { LEFT_PANELS } from 'constants/feature/panel-constants';

const updateWorkpaperElementsMapAction = createAction(
  'UPDATE_WORKPAPER_ELEMENTS_MAP_ACTION',
);
const updateWorkpaperElementsMapFromArrayAction = createAction(
  'UPDATE_WORKPAPER_ELEMENTS_MAP_FROM_ARRAY_ACTION',
);

export const updateWorkpaperElementsMap =
  ({ response }) =>
  async (dispatch, getState) => {
    if (getState().ui.statementPage.panels.left !== LEFT_PANELS.WORKPAPER)
      return;
    const updatedElementsArray = response.data.result
      ? response.data.result.elementEntityList[0]
      : response;
    if (response && updatedElementsArray) {
      dispatch(updateWorkpaperElementsMapAction(updatedElementsArray));
    }
  };

export const updateWorkpaperElementsMapFromArray =
  ({ elementsArray }) =>
  async (dispatch, getState) => {
    if (getState().ui.statementPage.panels.left !== LEFT_PANELS.WORKPAPER)
      return;
    if (elementsArray) {
      dispatch(updateWorkpaperElementsMapFromArrayAction(elementsArray));
    }
  };
